import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const ScheduleModal = ({ isOpen, onClose, onSchedule }) => {
  const [scheduleName, setScheduleName] = useState('');
  const [frequency, setFrequency] = useState('');
  const [recipients, setRecipients] = useState('');
  const [includeAttachment, setIncludeAttachment] = useState(true);

  const frequencyOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSchedule({
      name: scheduleName,
      frequency,
      recipients: recipients?.split(',')?.map(r => r?.trim()),
      includeAttachment,
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-md mx-4 modal-shadow">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
            <Icon name="Calendar" size={20} />
            Schedule Report
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full hover:bg-muted flex items-center justify-center transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label="Schedule Name"
            type="text"
            placeholder="e.g., Monthly Operations Report"
            value={scheduleName}
            onChange={(e) => setScheduleName(e?.target?.value)}
            required
          />

          <Select
            label="Frequency"
            options={frequencyOptions}
            value={frequency}
            onChange={setFrequency}
            placeholder="Select frequency"
            required
          />

          <Input
            label="Recipients"
            type="text"
            placeholder="email1@example.com, email2@example.com"
            description="Separate multiple emails with commas"
            value={recipients}
            onChange={(e) => setRecipients(e?.target?.value)}
            required
          />

          <Checkbox
            label="Include report as attachment"
            checked={includeAttachment}
            onChange={(e) => setIncludeAttachment(e?.target?.checked)}
          />

          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" fullWidth onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" variant="default" fullWidth iconName="Check">
              Schedule
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ScheduleModal;